"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <div class="swiftref-dialog"
        role="dialog"
        aria-labelledby=""
        aria-modal="true">
        <header>
            <div style="display: flex; align-items: center; gap: 8px;">
                <swiftref-icon ></swiftref-icon>
                <p class="p1-m" id="dialog-title"></p>
            </div>
            <span class="close-icon">x</span>
        </header>
        <div class="dialog-content">
            <slot></slot>
        </div>
        <footer class="dialog-footer">
            <slot name="cancel">
                <swiftref-button kind="secondary">Cancel</swiftref-button>
            </slot>
            <slot name="submit">
                <swiftref-button id="submit-button">Save</swiftref-button>
            </slot>
        </footer>
    </div>
`;
